import { render, staticRenderFns } from "./VideoEmbed.vue?vue&type=template&id=f2b7ed68"
import script from "./VideoEmbed.vue?vue&type=script&lang=js"
export * from "./VideoEmbed.vue?vue&type=script&lang=js"
import style0 from "./VideoEmbed.vue?vue&type=style&index=0&id=f2b7ed68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports